import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Chip,
  Divider,
} from "@mui/material";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import { ContextData } from "../../../../../../../context/Context";
import { Getrequest } from "../../../../../../../context/AxiosRequest";
import GetPersonData from "../../../../../../../context/GetPersonData";
import Loader from "../../../../../../../routes/Loader";
import Instruction from "./Instruction";



export default function ApplyLoanTable() {




  const { UserTokens, accesstoken } = useContext(ContextData);
  const [PersonData, setPersonData] = useState(null);
  const [LoanList, setLoanList] = useState([]);
  const [FilteredLoanList, setFilteredLoanList] = useState([]);
  const [OpenLoader, setOpenLoader] = useState(false);

  useEffect(() => {


    setOpenLoader(true);
    GetPersonData(UserTokens, accesstoken).then((data) => {
      if (data) setPersonData(data);
      setOpenLoader(false);
    });


  }, [UserTokens, accesstoken]);


  useEffect(() => {


    async function FetchData() {
      setOpenLoader(true);
      try {
        const response = await Getrequest("/auth/get_loan_list", accesstoken);
        setLoanList(response);
      } catch (err) {
        console.log(err.message);
      }
      setOpenLoader(false);
    }
    FetchData();


  }, [accesstoken]);


  useEffect(() => {

    if (PersonData && LoanList.length > 0) {
      const filteredList = LoanList.filter(
        (item) =>
          (item.qualification_type.toLowerCase() ===
            PersonData.edu_data[0].applying_for_type.toLowerCase() &&
            (item.resdential_type ===
              PersonData.bio_data[0].resdential_type ||
              item.resdential_type === "both")) ||
              item.qualification_type === "both"
      )
      setFilteredLoanList(filteredList);
    }


  }, [PersonData, LoanList]);



  return (
    <Box
      sx={{
        backgroundColor: "#f8f9fb",
        minHeight: "100vh",
        py: { xs: 3, md: 6 },
        px: { xs: 2, md: 5 },
      }}
    >
      {OpenLoader && (
        <Box sx={{ display: "flex",flexDirection:"column", alignItems:"center", justifyContent: "center", py: 8 }}>
          <CircularProgress color="primary" />
          <p className="mt-3">If no data display please: refresh the page</p>
        </Box>
      )}

      {!OpenLoader && (
        <>
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              mb: 4,
              fontWeight: 700,
              color: "rgb(0, 24, 69)",
              letterSpacing: 0.5,
            }}
          >
            <span className="font-serif"> Available Bank(s)</span>
          </Typography>

          <Grid container spacing={3}>
            {FilteredLoanList.length === 0 && (
              <Grid item xs={12}>
                <Typography
                  align="center"
                  sx={{
                    color: "gray",
                    fontWeight: 500,
                    mt: 4,
                    fontSize: "1rem",
                  }}
                >
                  No matching loan opportunities found.
                </Typography>
              </Grid>
            )}

            {FilteredLoanList.map((loan, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    overflow: "hidden",
                    transition: "0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 6px 25px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      background: "linear-gradient(135deg, rgb(0, 24, 69), #002b7a)",
                      color: "white",
                      p: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        textTransform: "uppercase",
                        textAlign: "center",
                        fontSize: "1.1rem",
                      }}
                    >
                      {loan.loan_name}
                    </Typography>
                  </Box>

                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <CloudDoneIcon sx={{ color: "rgb(0, 24, 69)", mr: 1 }} />
                      <Typography sx={{ fontWeight: 600 }}>
                        Type:{" "}
                        <span style={{ color: "gray", fontWeight: 500 }}>
                          {loan.loan_type}
                        </span>
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <RssFeedIcon sx={{ color: "rgb(0, 24, 69)", mr: 1 }} />
                      <Typography sx={{ fontWeight: 600 }}>
                        Qualification for:{" "}
                        <span style={{ color: "gray", fontWeight: 500 }}>
                          {loan.qualification_type}
                        </span>
                      </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Typography
                      variant="body2"
                      sx={{
                        color: "gray",
                        mb: 2,
                        lineHeight: 1.6,
                        minHeight: "60px",
                      }}
                    > 
                       <span className="font-mono">Read the Terms and Conditions carefully before Apply"</span>
                    </Typography>

                    <Box sx={{ textAlign: "center", mt: 2 }}>
                      <Instruction
                        type="instrct_apply"
                        value={loan.loan_description}
                        loan_applied={loan.loan_name}
                        loan_type={loan.loan_type}
                        loan_card_token={loan.token}
                        user_token={UserTokens}
                        setOpenLoader={setOpenLoader}
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Box>
  );
}
